export default __webpack_public_path__ + "static/media/photo-camera.74073638.svg";